import { FieldDefinition, FieldBuilder, MENU_CATEGORY_KEY, MENU_NAME_SUFFIX, MENU_SUBCATEGORY_KEY, MenuCategories, MenuSubcategories } from '@zendra/shared';
import { ActivityProcessParametrizationService } from '../proxy/controlling/controllers/activity-process-parametrization.service';
import { LevelService } from '../proxy/controlling/controllers/level.service';
import { StageService } from '../proxy/controlling/controllers/stage.service';
import { WbsService } from '../proxy/controlling/controllers/wbs.service';
import { ActivityPerNursery } from '@controlling/activity-per-nursery/activity-per-nursery';
import { NurseryActivityQualityControl } from '@controlling/nursery-activity-quality-control/nursery-activity-quality-control';
import { MovementTypeService } from '../proxy/controlling/controllers/movement-type.service';

FieldBuilder.setNamespace('Controlling');

export const NURSERYACTIVITYPARAMETER_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .checkbox('hasRfid', 'Entity.NurseryActivityParameter.HasRFID')
    .build(),
  FieldBuilder
    .checkbox('isProductive', 'Entity.NurseryActivityParameter.IsProductive')
    .build(),
  FieldBuilder
    .checkbox('mustMoveStock', 'Entity.NurseryActivityParameter.MustMoveStock')
    .build(),
  FieldBuilder
    .foreignKey('levelId', 'Entity.Level', LevelService)
    .displayFromNested('level.name') 
    .sortBy('level.name') 
    .build(),
  FieldBuilder
    .foreignKey('stageId', 'Entity.Stage', StageService)
    .displayFromNested('stage.name') 
    .sortBy('stage.name') 
    .build(),
  FieldBuilder
    .foreignKey('wbsId', 'Entity.Wbs', WbsService)
    .displayFromNested('wbs.name') 
    .sortBy('wbs.name') 
    .build(),
  FieldBuilder
    .foreignKey('movementTypeId', 'Entity.MovementType', MovementTypeService)
    .display('sapCode')
    .displayFromNested('movementType.sapCode')
    .sortBy('movementType.sapCode')
    .build(),
  FieldBuilder
    .foreignKey('activityProcessParametrizationId', 'Entity.ActivityProcessParametrization', ActivityProcessParametrizationService)
    .required()
    .display('name')
    .keyField('id')
    .hideInChildForms()
    .build(),
];

export const NURSERYACTIVITYPARAMETER_CONFIG = {
  entityName: 'NurseryActivityParameter',
  localizationKey: 'Controlling::Entity.NurseryActivityParameter',
  fields: NURSERYACTIVITYPARAMETER_FIELDS,
  permission: 'ControllingActivities.NurseryActivityParameters',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
  children: [
      {
        entityName: 'ActivityPerNursery',
        foreignKeyField: 'nurseryActivityParameterId',
        localizationKey: 'Controlling::Entity.ActivityPerNursery',
        component: ActivityPerNursery,
      },
      {
        entityName: 'NurseryActivityQualityControl',
        foreignKeyField: 'nurseryActivityParameterId',
        localizationKey: 'Controlling::Entity.NurseryActivityQualityControl',
        component: NurseryActivityQualityControl,
      },
    ]
};
